<template>
  <div
    className="group15 flex-col"
    :style="{
      width: '60%',
    }"
  >
    <div className="bd6 flex-row">
      <div className="box3 flex-row">
        <div
          :style="{
            height:'360px',
          }"
          className="group16-0 flex-col"
          v-for="(item) in deviceList"
          :key="item.id"
        >
          <div className="layer5-0 flex-col">
            <span className="word11-0">{{ item.deviceName }}</span>
            <div
              :id="'show_video' + (item.id)"
              className="pic1-0"
            ></div>
            <div className="section4-0 flex-row">
              <div
                className="block1-0 flex-col"
                @click="releaseOut(item, 'on')"
              >
                <span className="word12-0">开闸放行</span>
              </div>

              <div
                className="block2-01 flex-col"
                style="width: 20%"
                @click="onVideoIndex(item, 'snap')"
              >
                <span className="word12-0">抓拍</span>
              </div>

              <div
                className="block2-0 flex-col"
                @click="onVideoIndex(item, 'off')"
              >
                <span className="txt1-0">关闸</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <el-dialog title="选择开闸原因" v-model="openDoorDialogVisible" :modal-append-to-body="false" width="30%" center>
    <div class="Box">
      <div v-for="(item, index) of openDoorReason" :key="index" :class="index === reasonIndex ? 'reasonBox_ac' : 'reasonBox'"
           @click="onReason(index)">
        {{ item }}
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="danger" @click="releaseOutExt()" :disabled="reasonIndex === ''">确 定</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- 补录入出场弹窗 -->
  <el-dialog
      v-model="supplementaryEntryConfirmVisible"
      :title="showInInfo ? '补录入场' : '补录出场'"
      :modal-append-to-body="false"
      width="40%"
      center
      :close-on-click-modal="false"
      class="release-in-dialog"
  >
    <div class="release-in-card">
      <el-form label-width="96px" label-position="left" class="release-in-form">
        <el-form-item label="车牌">
          <div class="edit-plate-field" ref="platePickerRef">
            <div class="edit-plate-composite">
              <el-input
                  v-model="carParkUseLog.numberPlate"
                  class="edit-plate-body-input"
                  placeholder="请输入完整车牌号"
                  clearable
                  @focus="provincePickerVisible = true"
                  @change="checkNumberPlate"
              />
              <button
                  type="button"
                  class="edit-plate-province-badge"
                  title="选择省份简称"
                  @click.stop="toggleProvincePicker"
              >
                {{ getCurrentProvince() || "▼" }}
              </button>
            </div>
            <div
                v-show="provincePickerVisible"
                class="edit-plate-keyboard"
                @click.stop
            >
              <div
                  v-for="(row, ri) in plateKeyboardRows"
                  :key="ri"
                  class="edit-plate-key-row"
              >
                <button
                    v-for="cell in row"
                    :key="cell"
                    type="button"
                    class="edit-plate-key"
                    :class="{ 'is-active': cell === getCurrentProvince() }"
                    @click="pickProvince(cell)"
                >
                  {{ cell }}
                </button>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="类型">
          <span class="release-in-value">
            <el-select
                v-model="carParkUseLog.carType"
                placeholder="请选择"
                :clearable="true"
            >
                <el-option
                    v-for="item in carTypeList"
                    :key="item.flagKey"
                    :label="item.name"
                    :value="item.flagKey"
                >
                </el-option>
              </el-select>
          </span>
        </el-form-item>
        <el-form-item v-if="showInInfo" label="入场时间">
          <span class="release-in-value">
            <el-date-picker
                v-model="carParkUseLog.newInTime"
                type="datetime"
                placeholder="请选择"
                clearable
            />
          </span>
        </el-form-item>
        <el-form-item v-if="showOutInfo" label="出场时间">
          <span class="release-in-value">
            <el-date-picker
                v-model="carParkUseLog.newOutTime"
                type="datetime"
                placeholder="请选择"
                clearable
            />
          </span>
        </el-form-item>
        <el-form-item v-if="showInInfo" label="入场通道">
          <span class="release-in-value">
            {{ carParkUseLog.inCheckPointName }}
          </span>
        </el-form-item>
        <el-form-item v-if="showOutInfo" label="出场通道">
          <span class="release-in-value">
            {{ carParkUseLog.outCheckPointName }}
          </span>
        </el-form-item>
      </el-form>
    </div>
    <div class="Box">
      <div v-for="(item, index) of releaseInReason" :key="index" :class="index === reasonIndex ? 'reasonBox_ac' : 'reasonBox'"
           @click="onReason(index)">
        {{ item }}
      </div>
    </div>

    <template #footer>
      <div class="release-in-footer">
        <el-button class="release-in-primary" type="primary" @click="supplementaryEntryConfirm(1,1)">
          {{ openDoorConfirmText }}
        </el-button>
        <el-button type="warning" v-if="carParkUseLog.numberPlate" @click="supplementaryEntryConfirm(0,0)">
          补录
        </el-button>
        <el-button @click="supplementaryEntryConfirmVisible = false">取消开闸</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import {
  getCarparkDeviceAdmin,
  getCheckPointByQuery,
  getRemoteVideo,
  manualEntryUseLog,
  openOrCloseDoor
} from "@/network/api";
import Jessibuca from "../../../public/jessibuca";
import dayjs from "dayjs";

/**
 * 省份简称键盘布局（与常见补录/选牌 UI 一致，10 列 × 4 行）
 * 含港澳及部分特殊号牌字头
 */
const PLATE_KEYBOARD_ROWS = [
  ["京", "津", "沪", "渝", "冀", "豫", "云", "辽", "黑", "湘"],
  ["皖", "鲁", "新", "苏", "浙", "赣", "鄂", "桂", "甘", "晋"],
  ["蒙", "陕", "吉", "闽", "贵", "粤", "青", "藏", "川", "宁"],
  ["琼", "使", "领", "电", "警", "学", "挂", "港", "澳", "试"],
  ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  ["Q", "W", "E", "R", "T", "Y", "U", "P", "A", "S"],
  ["D", "F", "G", "H", "J", "K", "L", "Z", "X", "C"],
  ["V", "B", "N", "M", "临", "", "", "", "", ""],
];

const PLATE_VALID_FIRST_CHARS = new Set(PLATE_KEYBOARD_ROWS.flat());

export default {
  data() {
    return {
      deviceList: [],
      socket: null,
      reasonIndex: "",
      currentCtrAction: "",
      currentCtrDevice: {},
      openDoorDialogVisible: false,
      supplementaryEntryConfirmVisible: false,
      supplementaryEntryItem: {
        inCheckPointName: '',
        inChannelName: '',
        inLaneName: '',
        inGateName: '',
        inPassageName: '',
        inDeviceName: '',
        checkPointName: '',
        channelName: '',
        laneName: '',
        gateName: '',
        deviceName: '',
        inCheckPoint: '',
        checkPoint: ''
      },
      editCarDialogVisible: false,
      editCarItem: null,
      plateKeyboardRows: PLATE_KEYBOARD_ROWS,
      provincePickerVisible: false,
      openDoorConfirmText: '无车直接开闸',
      carParkUseLog: {
        id: '',
        numberPlate: '',
        inCheckPointId: '',
        inCheckPointName: '',
        outCheckPointId: '',
        outCheckPointName: '',
        remarks: '',
        carType: 'temporary_car',
        carTypeName: '',
        inTime: '',
        newInTime: '',
        outTime: '',
        newOutTime: '',
        deviceId: '',
        openDoor: 1,
        snap: 1
      },
      showInInfo: true,
      showOutInfo: false
    };

  },
  computed: {
    ...mapState(["parkSwitch", "carParkIndex", "carParkList","openDoorReason","carTypeList","releaseInReason"]),
  },
  // 获取停车场首次加载时 第一个停车场的所有硬件
  // 监听 所选停车场的 index 当发生改变时 应当重新获取所有硬件
  // 刷新页面作用 --- 重置所有ws
  watch: {
    carParkList() {
      this.getHardwareList();
    },
    carParkIndex() {
      this.getHardwareList();
      window.location.reload();
    }
  },
  methods: {
    getNameByFlagKey(flagKey) {
      const arr = this.carTypeList;
      const foundItem = arr.find((item) => item.flagKey === flagKey);
      // return foundItem ? foundItem.name : null;
      return foundItem ? foundItem.name : '---';
    },
    getInChannelText(item) {
      if (!item) return "-";
      return (
          item.inCheckPointName ||
          item.inChannelName ||
          item.inLaneName ||
          item.inGateName ||
          item.inPassageName ||
          item.inDeviceName ||
          item.checkPointName ||
          item.channelName ||
          item.laneName ||
          item.gateName ||
          item.deviceName ||
          item?.inCheckPoint?.name ||
          item?.checkPoint?.name ||
          "-"
      );
    },
    /** 获取当前输入框中的省份简称（若首字合法则返回，否则返回空） */
    getCurrentProvince() {
      const raw = (this.carParkUseLog.numberPlate || "").trim();
      if (!raw) return "";
      const first = raw.charAt(0);
      return PLATE_VALID_FIRST_CHARS.has(first) ? first : "";
    },
    /** 点击省份键盘：输入框已有内容则替换首字，否则填入 */
    pickProvince(cell) {
      // const raw = (this.carParkUseLog.numberPlate || "").trim();
      // if (raw && PLATE_VALID_FIRST_CHARS.has(raw.charAt(0))) {
      //   this.carParkUseLog.numberPlate = cell + raw.slice(1);
      // } else {
      //   this.carParkUseLog.numberPlate = cell;
      // }
      // this.provincePickerVisible = false;
      this.carParkUseLog.numberPlate += cell;
    },
    toggleProvincePicker() {
      this.provincePickerVisible = !this.provincePickerVisible;
    },
    closeProvincePickerOutside(e) {
      const el = this.$refs.platePickerRef;
      if (!el || !this.provincePickerVisible) return;
      if (el.contains(e.target)) return;
      this.provincePickerVisible = false;
    },
    checkNumberPlate(){
      this.openDoorConfirmText = this.carParkUseLog.numberPlate ? '补录+开闸' : "无车直接开闸";
    },
    async supplementaryEntryConfirm(openDoor, snap) {
      if(this.carParkUseLog.numberPlate) {
        if(this.carParkUseLog.newInTime) {
          this.carParkUseLog.inTime = dayjs(this.carParkUseLog.newInTime).valueOf();
        }
        if(this.carParkUseLog.newOutTime) {
          this.carParkUseLog.outTime = dayjs(this.carParkUseLog.newOutTime).valueOf();
        }
        this.carParkUseLog.openDoor = openDoor;
        this.carParkUseLog.snap = snap;
        var { message, mixMessage, code } = await manualEntryUseLog(this.carParkUseLog);
        // console.log(data);
        if (code === 10002) {
          this.$message({
            message,
            type: "success",
          });
          this.supplementaryEntryConfirmVisible = false;
          this.resetCarParkUseLog();
        } else {
          this.$message.error(message+","+mixMessage);
        }
      }else{
        await this.onVideoIndex(this.currentCtrDevice, this.currentCtrAction);
        this.supplementaryEntryConfirmVisible = false;
      }
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script"); // 创建一个新的 <script> 元素
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () =>
            reject(new Error(`Script load error for ${src}`));
        document.head.appendChild(script); // 把<script>元素添加到头部，这样浏览器就会开始加载并执行脚本
      });
    },
    initPlayer(data) {
      // 使用 BASE_URL 动态获取基础路径，兼容不同部署环境
      const baseUrl = (process.env.VUE_APP_PUBLIC_PATH || '/').replace(/\/$/, '');
      this.loadScript(`${baseUrl}/Rtsp2WPlayer.min.js`).then(() => {
        // 确保 Rtsp2WPlayer 被加载到 window 对象中
        if (window.Rtsp2WPlayer) {
          for (const i in data) {
            let info = data[i];
            let playerUrl = "";
            switch (info.brand){
              case "zhen_shi":
                playerUrl = `rtsp://${info.ip}:8557/h264`;
                break;
              case "hua_xia":
                playerUrl = `rtsp://${info.ip}/stream_main`;
                break;
              case "qian_yi":
                playerUrl = `rtsp://${info.ip}:50000/video`;
                break;
              case "xlut":
                playerUrl = `rtsp://${info.ip}:554/h264ESVideoTest`;
                break;
              case "qianlima":
                playerUrl = `rtsp://${info.ip}:8557/h264`;
                break;
            }
            const player = new window.Rtsp2WPlayer({
              serverPath: "http://127.0.0.1:8083",
              containerId: `show_video${info.id}`,
              logEnabled: true,
              style: {
                controls: true,
              },
              onconnectionstatechange: function (state) {
                console.log("连接状态：", state);
                if (state === "disconnected" || state === "failed") {
                  setTimeout(() => {
                    console.log("重连...");
                    player.play(playerUrl); // 确保调用了正确的 play 方法
                  }, 5000);
                }
              },
            });
            player.play(playerUrl); // 播放视频流
          }

        } else {
          console.error("Rtsp2WPlayer is not loaded.");
        }
      });
    },
    //远程视频流
    initRemotePlayer(data) {
      // 确保 jessibuca 被加载到 window 对象中
      for (const i in data) {
        let info = data[i];
        switch (info.brand){
          case "zhen_shi":
            getRemoteVideo({
              id: info.id,
              videType: 'flv',
            }).then((result)=>{
              this.executePlay(`show_video${info.id}`, result.data);
            });
            break;
          case "hua_xia":

            break;
          case "qian_yi":

            break;
          case "xlut":

            break;
          case "qianlima":

                break;
            }
          }
    },
    // 图片放大功能
    showBigImage(index) {
      var mainDiv = document.getElementById(`show_video${index}`);
      if (mainDiv.classList.contains("bigImage")) {
        mainDiv.classList.remove("bigImage");
      } else {
        mainDiv.classList.add("bigImage");
      }
    },
    // 执行视频播放功能
    executePlay(id, playerUrl) {
      let $container = document.getElementById(id);
      let jessibuca = new Jessibuca({
        container: $container,
        videoBuffer: 0.2,
        isResize: false,
        text: "",
        loadingText: "加载中",
        debug: true,
        showBandwidth: true,
        operateBtns: {
          fullscreen: true,
          screenshot: true,
          play: true,
          audio: true,
        },
        forceNoOffscreen: true,
        isNotMute: false,
      });
      jessibuca.play(playerUrl);
    },
    async getHardwareList() {
      var { data, code } = await getCarparkDeviceAdmin({
        areaId: this.carParkIndex,
        deviceType: 2,
        page: 1,
        size: 100,
        dutying: 1
      });
      if (code != 10002) return;
      this.deviceList = data;
      this.getVideo(data);
    },
    getVideo(data) {
      let localVideoes = [];
      let remoteVideoes = [];
      for (const i in data) {
        if(data[i].videoMode===0){
          localVideoes.push(data[i]);
        }else{
          remoteVideoes.push(data[i]);
        }
      }
      if(localVideoes.length > 0){
        this.initPlayer(localVideoes);
      }
      if(remoteVideoes.length > 0){
        this.initRemotePlayer(remoteVideoes);
      }

    },
    onReason(index) {
      this.reasonIndex = index;
    },
    // 点击视频开闸关闸抓拍
    async onVideoIndex(item, action) {
      var { message, code } = await openOrCloseDoor({
        deviceId: item.id,
        reason: this.openDoorReason[this.reasonIndex],
        action,
      });
      // console.log(data);
      if (code == 10002) {
        this.$message({
          message,
          type: "success",
        });
      } else {
        this.$message.error(message);
      }
      this.openDoorDialogVisible = false;
    },
    resetCarParkUseLog(){
      this.carParkUseLog.id = '';
      this.carParkUseLog.numberPlate = '';
      this.carParkUseLog.inCheckPointId= '';
      this.carParkUseLog.inCheckPointName= '';
      this.carParkUseLog.outCheckPointId= '';
      this.carParkUseLog.outCheckPointName= '';
      this.carParkUseLog.remarks= '';
      this.carParkUseLog.carType= 'temporary_car';
      this.carParkUseLog.carTypeName= '';
      this.carParkUseLog.inTime= '';
      this.carParkUseLog.newInTime= '';
      this.carParkUseLog.outTime= '';
      this.carParkUseLog.newOutTime= '';
    },
    releaseOut(item, action){
      this.openDoorConfirmText = '无车直接开闸';
      this.resetCarParkUseLog();
      //判断该设备所在的通道方向
      getCheckPointByQuery({
        page: 1,
        size: 1,
        id: item.checkPointId,
      }).then((result)=>{
        if(result.code !== 10002){
          return;
        }
        this.currentCtrAction = action;
        this.supplementaryEntryConfirmVisible = true;
        this.carParkUseLog.deviceId = item.id;
        this.currentCtrDevice = item;
        if(result.data[0].features==='in'){
          this.showInInfo = true;
          this.showOutInfo = false;
          this.carParkUseLog.inCheckPointId = item.checkPointId;
          this.carParkUseLog.inCheckPointName = item.checkPointName;
        }else{
          this.showInInfo = false;
          this.showOutInfo = true;
          this.carParkUseLog.outCheckPointId = item.checkPointId;
          this.carParkUseLog.outCheckPointName = item.checkPointName;
        }
      });

    },
    releaseOutExt(){
      this.onVideoIndex(this.currentCtrDevice, this.currentCtrAction)
    },
  },
};
</script>

<style>
.bigImage {
  width: 90vw;
  height: 90vh;
  position: fixed;
  left: 5vw;
  top: 5vh;
  z-index: 99999;
  transition: all 0.5s;
}
.jessibuca-container {
  position: relative !important;
  display: block !important;
  width: 96% !important;
  height: 66% !important;
  overflow: hidden !important;
}
.reasonBox {
  width: 90px;
  height: 36px;
  background: #efefef;
  border-radius: 3px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC, serif;
  font-weight: 500;
  color: #323233;
  line-height: 36px;
  margin-bottom: 16px;
  /* margin-right: 20px; */
  text-align: center;
}

.reasonBox_ac {
  width: 90px;
  height: 36px;
  background: #fc4408;
  border-radius: 3px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC, serif;
  font-weight: 500;
  color: #ffffff;
  line-height: 36px;
  margin-bottom: 16px;
  /* margin-right: 20px; */
  text-align: center;
}

.Box {
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.release-in-card {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background: #f6f6f6;
  padding: 18px 18px 4px;
  overflow: visible;
}

.release-in-form :deep(.el-form-item) {
  margin-bottom: 14px;
}

.release-in-form :deep(.el-form-item__label) {
  color: #999999;
  font-weight: 500;
}

.release-in-value {
  color: #373c40;
  font-size: 14px;
  font-weight: 500;
}

/* 纠错：省份网格 + 车牌输入（参考补录选牌样式） */
.edit-plate-field {
  position: relative;
  width: 100%;
}

.edit-plate-composite {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 36px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;
}

.edit-plate-composite:focus-within {
  border-color: rgba(8, 123, 252, 0.6);
}

.edit-plate-body-input {
  flex: 1;
  min-width: 0;
}

.edit-plate-body-input :deep(.el-input__wrapper) {
  box-shadow: none !important;
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  padding-left: 10px;
}

.edit-plate-body-input :deep(.el-input__inner) {
  text-align: left;
  border: none !important;
  box-shadow: none !important;
}

.edit-plate-province-badge {
  flex-shrink: 0;
  width: 36px;
  margin: 2px;
  border: none;
  border-radius: 4px;
  background: rgba(8, 123, 252, 1);
  color: #fff;
  cursor: pointer;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.edit-plate-province-badge:hover {
  background: rgba(8, 123, 252, 0.85);
}

.edit-plate-keyboard {
  position: absolute;
  left: 0;
  top: calc(100% + 6px);
  z-index: 20;
  padding: 10px;
  background: #f0f2f5;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #e4e7ed;
  width: 100%;
}

.edit-plate-key-row {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 6px;
  margin-bottom: 6px;
}

.edit-plate-key-row:last-child {
  margin-bottom: 0;
}

.edit-plate-key {
  width: 100%;
  aspect-ratio: 1;
  min-width: 0;
  min-height: 32px;
  padding: 0;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
  font-size: 30px;
  font-weight: 500;
  color: #303133;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.edit-plate-key:hover {
  border-color: rgba(8, 123, 252, 0.5);
  color: rgba(8, 123, 252, 1);
}

.edit-plate-key.is-active {
  background: #ff9e3c;
  border-color: #ff9e3c;
  color: #fff;
}

.release-in-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.release-in-primary {
  background: rgba(8, 123, 252, 1);
  border-color: rgba(8, 123, 252, 1);
}

.release-in-primary:hover,
.release-in-primary:focus {
  background: rgba(8, 123, 252, 0.9);
  border-color: rgba(8, 123, 252, 0.9);
}

.release-in-dialog :deep(.el-dialog__header) {
  padding-top: 18px;
}

.release-in-dialog :deep(.el-dialog__title) {
  font-size: 20px;
  font-weight: 500;
  color: #373c40;
}

.release-in-dialog :deep(.el-dialog__body) {
  padding-top: 12px;
  padding-bottom: 8px;
  overflow: visible;
}

</style>
